import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import firebaseDb from '../firebase';
import { collection, getDocs, query, orderBy} from 'firebase/firestore';

export default (props) => {
    let { record, setRecord, name, disabled } = props;
    let [stream, setStream] = useState([]);

    let get = async () => {
        const streamRef = collection(firebaseDb, 'stream');
        const streamQuery = query(streamRef,  orderBy("active", "desc"),orderBy("order", "asc"));
        const streamSnapshot = await getDocs(streamQuery);
        const streamList = streamSnapshot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data(),
            }
        });
        setStream(streamList)
    }

    useEffect(() => {
        get()
    }, [])

    return <Select  disabled={disabled} className="button4" value={record[name] || []} mode='single' placeholder="Yayın Seçin"
        onChange={v => setRecord({ ...record, [name]: v })}>
        {(stream) && stream.map(b =>
            <Select.Option key={b.id} value={b.sessionId} >{b.name}</Select.Option>)}
    </Select>;
};